module.exports = __webpack_public_path__ + "static/media/Sand.2767e301.jpg";